<script setup lang="ts">
</script>

<template>
	<h1>Time<span>Flies</span></h1>
</template>

<style scoped>
	h1 {
		display: flex;
		align-items: center;
		gap: 0.25rem;
		font-size: var(--font-size-xlarge);
		font-weight: 300;
	}

	h1 span {
		font-weight: bold;
	}
</style>